<mat-card class="card_content">

    <mat-card-title>
        Add Product
    </mat-card-title>

    <mat-card-content >

        <form [formGroup]="productForm">

            <mat-form-field class="full-width">

                <mat-label>Product Name</mat-label>
                <input matInput placeholder="Enter product name" type="text" formControlName="productName"/>

            </mat-form-field>

            <mat-form-field class="full-width">

                <mat-label>Product Price</mat-label>
                <input matInput placeholder="Enter product price" type="number" formControlName="productPrice"/>

            </mat-form-field>

            <mat-slide-toggle formControlName="isStack"  class="full-width">
                Stack status
            </mat-slide-toggle>

            <button mat-raised-button [disabled]="!productForm.valid" (click)="addProduct()">
                Submit
            </button>
            


        </form>

        <!-- <h2>{{ productForm.value | json }}</h2> -->


    </mat-card-content>

</mat-card>